// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_city.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { City } from "./city_pb";
import { file_travplaces_v1_city } from "./city_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/admin_city.proto.
 */
export const file_travplaces_v1_admin_city: GenFile = /*@__PURE__*/
  fileDesc("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", [file_travplaces_v1_audit, file_travplaces_v1_authz, file_travplaces_v1_city]);

/**
 * @generated from message travplaces.v1.ListAllCitiesRequest
 */
export type ListAllCitiesRequest = Message<"travplaces.v1.ListAllCitiesRequest"> & {
};

/**
 * Describes the message travplaces.v1.ListAllCitiesRequest.
 * Use `create(ListAllCitiesRequestSchema)` to create a new message.
 */
export const ListAllCitiesRequestSchema: GenMessage<ListAllCitiesRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 0);

/**
 * @generated from message travplaces.v1.ListAllCitiesResponse
 */
export type ListAllCitiesResponse = Message<"travplaces.v1.ListAllCitiesResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.City cities = 1;
   */
  cities: City[];
};

/**
 * Describes the message travplaces.v1.ListAllCitiesResponse.
 * Use `create(ListAllCitiesResponseSchema)` to create a new message.
 */
export const ListAllCitiesResponseSchema: GenMessage<ListAllCitiesResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 1);

/**
 * AdminCreateCityRequest mirrors the legacy adminApi.createCity body: a
 * bounding box in [min_lng, min_lat, max_lng, max_lat] order (carried as four
 * doubles), from which the centre is derived.
 *
 * @generated from message travplaces.v1.AdminCreateCityRequest
 */
export type AdminCreateCityRequest = Message<"travplaces.v1.AdminCreateCityRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string timezone = 3;
   */
  timezone: string;

  /**
   * "imperial" | "metric"; defaults to "imperial" when empty
   *
   * @generated from field: string units = 4;
   */
  units: string;

  /**
   * ISO 3166-1 alpha-2; defaults to "US" when empty
   *
   * @generated from field: string country_code = 5;
   */
  countryCode: string;

  /**
   * @generated from field: double bbox_min_lng = 6;
   */
  bboxMinLng: number;

  /**
   * @generated from field: double bbox_min_lat = 7;
   */
  bboxMinLat: number;

  /**
   * @generated from field: double bbox_max_lng = 8;
   */
  bboxMaxLng: number;

  /**
   * @generated from field: double bbox_max_lat = 9;
   */
  bboxMaxLat: number;

  /**
   * defaults to 500 when zero
   *
   * @generated from field: int32 default_avoid_distance_m = 10;
   */
  defaultAvoidDistanceM: number;
};

/**
 * Describes the message travplaces.v1.AdminCreateCityRequest.
 * Use `create(AdminCreateCityRequestSchema)` to create a new message.
 */
export const AdminCreateCityRequestSchema: GenMessage<AdminCreateCityRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 2);

/**
 * @generated from message travplaces.v1.AdminCreateCityResponse
 */
export type AdminCreateCityResponse = Message<"travplaces.v1.AdminCreateCityResponse"> & {
  /**
   * @generated from field: travplaces.v1.City city = 1;
   */
  city?: City | undefined;
};

/**
 * Describes the message travplaces.v1.AdminCreateCityResponse.
 * Use `create(AdminCreateCityResponseSchema)` to create a new message.
 */
export const AdminCreateCityResponseSchema: GenMessage<AdminCreateCityResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 3);

/**
 * UpdateCityRequest is a partial patch: only the fields that are set are
 * written. The bounding box is patched as a unit — set all four corners
 * together and the centre is re-derived.
 *
 * @generated from message travplaces.v1.UpdateCityRequest
 */
export type UpdateCityRequest = Message<"travplaces.v1.UpdateCityRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional string timezone = 3;
   */
  timezone?: string | undefined;

  /**
   * @generated from field: optional string units = 4;
   */
  units?: string | undefined;

  /**
   * @generated from field: optional string country_code = 5;
   */
  countryCode?: string | undefined;

  /**
   * @generated from field: optional int32 default_avoid_distance_m = 6;
   */
  defaultAvoidDistanceM?: number | undefined;

  /**
   * @generated from field: optional double bbox_min_lng = 7;
   */
  bboxMinLng?: number | undefined;

  /**
   * @generated from field: optional double bbox_min_lat = 8;
   */
  bboxMinLat?: number | undefined;

  /**
   * @generated from field: optional double bbox_max_lng = 9;
   */
  bboxMaxLng?: number | undefined;

  /**
   * @generated from field: optional double bbox_max_lat = 10;
   */
  bboxMaxLat?: number | undefined;
};

/**
 * Describes the message travplaces.v1.UpdateCityRequest.
 * Use `create(UpdateCityRequestSchema)` to create a new message.
 */
export const UpdateCityRequestSchema: GenMessage<UpdateCityRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 4);

/**
 * @generated from message travplaces.v1.UpdateCityResponse
 */
export type UpdateCityResponse = Message<"travplaces.v1.UpdateCityResponse"> & {
  /**
   * @generated from field: travplaces.v1.City city = 1;
   */
  city?: City | undefined;
};

/**
 * Describes the message travplaces.v1.UpdateCityResponse.
 * Use `create(UpdateCityResponseSchema)` to create a new message.
 */
export const UpdateCityResponseSchema: GenMessage<UpdateCityResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 5);

/**
 * @generated from message travplaces.v1.UnpublishCityRequest
 */
export type UnpublishCityRequest = Message<"travplaces.v1.UnpublishCityRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.UnpublishCityRequest.
 * Use `create(UnpublishCityRequestSchema)` to create a new message.
 */
export const UnpublishCityRequestSchema: GenMessage<UnpublishCityRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 6);

/**
 * @generated from message travplaces.v1.UnpublishCityResponse
 */
export type UnpublishCityResponse = Message<"travplaces.v1.UnpublishCityResponse"> & {
  /**
   * What is done, and what is left.
   *
   * Hiding the city from the planner is immediate. Removing it from the map
   * and the routing tiles is not, and cannot be: both are ONE artefact built
   * from every extract at once, so a city leaves them only when they are
   * rebuilt without it. Dropping its extract is what makes that rebuild
   * exclude it; until the rebuild runs, the old tiles still describe it.
   *
   * @generated from field: string note = 1;
   */
  note: string;

  /**
   * Whether a rebuild is now needed to finish the job — false when the city
   * was never in the shared data to begin with.
   *
   * @generated from field: bool rebuild_needed = 2;
   */
  rebuildNeeded: boolean;
};

/**
 * Describes the message travplaces.v1.UnpublishCityResponse.
 * Use `create(UnpublishCityResponseSchema)` to create a new message.
 */
export const UnpublishCityResponseSchema: GenMessage<UnpublishCityResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 7);

/**
 * @generated from message travplaces.v1.AdminDeleteCityRequest
 */
export type AdminDeleteCityRequest = Message<"travplaces.v1.AdminDeleteCityRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.AdminDeleteCityRequest.
 * Use `create(AdminDeleteCityRequestSchema)` to create a new message.
 */
export const AdminDeleteCityRequestSchema: GenMessage<AdminDeleteCityRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 8);

/**
 * @generated from message travplaces.v1.AdminDeleteCityResponse
 */
export type AdminDeleteCityResponse = Message<"travplaces.v1.AdminDeleteCityResponse"> & {
  /**
   * @generated from field: bool deleted = 1;
   */
  deleted: boolean;

  /**
   * best-effort note; staged tile/extract cleanup is not run here
   *
   * @generated from field: string note = 2;
   */
  note: string;
};

/**
 * Describes the message travplaces.v1.AdminDeleteCityResponse.
 * Use `create(AdminDeleteCityResponseSchema)` to create a new message.
 */
export const AdminDeleteCityResponseSchema: GenMessage<AdminDeleteCityResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 9);

/**
 * FetchBoundaryRequest carries the city and an optional place-name query. The
 * query is accepted for compatibility but unused in this simplified handler.
 *
 * @generated from message travplaces.v1.FetchBoundaryRequest
 */
export type FetchBoundaryRequest = Message<"travplaces.v1.FetchBoundaryRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * @generated from field: string query = 2;
   */
  query: string;
};

/**
 * Describes the message travplaces.v1.FetchBoundaryRequest.
 * Use `create(FetchBoundaryRequestSchema)` to create a new message.
 */
export const FetchBoundaryRequestSchema: GenMessage<FetchBoundaryRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 10);

/**
 * @generated from message travplaces.v1.FetchBoundaryResponse
 */
export type FetchBoundaryResponse = Message<"travplaces.v1.FetchBoundaryResponse"> & {
  /**
   * the city's name (no external geocode performed)
   *
   * @generated from field: string matched = 1;
   */
  matched: string;

  /**
   * area of the bounding box, in km^2
   *
   * @generated from field: double area_km2 = 2;
   */
  areaKm2: number;

  /**
   * always 100 here: the bbox is the outline
   *
   * @generated from field: double percent_of_bbox = 3;
   */
  percentOfBbox: number;

  /**
   * false: bbox used as the outline, not a real boundary
   *
   * @generated from field: bool exact = 4;
   */
  exact: boolean;
};

/**
 * Describes the message travplaces.v1.FetchBoundaryResponse.
 * Use `create(FetchBoundaryResponseSchema)` to create a new message.
 */
export const FetchBoundaryResponseSchema: GenMessage<FetchBoundaryResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 11);

/**
 * @generated from message travplaces.v1.SystemStatusRequest
 */
export type SystemStatusRequest = Message<"travplaces.v1.SystemStatusRequest"> & {
};

/**
 * Describes the message travplaces.v1.SystemStatusRequest.
 * Use `create(SystemStatusRequestSchema)` to create a new message.
 */
export const SystemStatusRequestSchema: GenMessage<SystemStatusRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 12);

/**
 * @generated from message travplaces.v1.SystemStatusResponse
 */
export type SystemStatusResponse = Message<"travplaces.v1.SystemStatusResponse"> & {
  /**
   * @generated from field: bool database_ok = 1;
   */
  databaseOk: boolean;

  /**
   * @generated from field: string database_detail = 2;
   */
  databaseDetail: string;

  /**
   * @generated from field: int32 cities_total = 3;
   */
  citiesTotal: number;

  /**
   * @generated from field: int32 cities_ready = 4;
   */
  citiesReady: number;

  /**
   * @generated from field: repeated travplaces.v1.EngineStatus engines = 5;
   */
  engines: EngineStatus[];

  /**
   * Whether GOOGLE_PLACES_API_KEY is set on the API process. The key itself
   * never leaves the server; the admin panel only needs to know whether
   * external place search can be switched on at all, so it can say "no key"
   * rather than offering a toggle that silently does nothing.
   *
   * @generated from field: bool external_search_key_configured = 6;
   */
  externalSearchKeyConfigured: boolean;

  /**
   * The job types this deployment will refuse, and why.
   *
   * Same reason as the key above: a deployment that serves prebuilt city data
   * has no container runtime, so the basemap build cannot run there — and that
   * is known at boot, not discovered by running it. Without this the panel
   * offers a button whose only possible outcome is a red failure, which reads
   * as a broken deployment rather than a job that belongs somewhere else.
   *
   * @generated from field: repeated travplaces.v1.UnavailableJob unavailable_jobs = 7;
   */
  unavailableJobs: UnavailableJob[];
};

/**
 * Describes the message travplaces.v1.SystemStatusResponse.
 * Use `create(SystemStatusResponseSchema)` to create a new message.
 */
export const SystemStatusResponseSchema: GenMessage<SystemStatusResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 13);

/**
 * UnavailableJob is one job type this deployment cannot run, with the refusal
 * the API would give. The reason is written for whoever has to act on it: it
 * names the artifact or the setting to change, not the mechanism that is
 * missing.
 *
 * @generated from message travplaces.v1.UnavailableJob
 */
export type UnavailableJob = Message<"travplaces.v1.UnavailableJob"> & {
  /**
   * "basemap_build"
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message travplaces.v1.UnavailableJob.
 * Use `create(UnavailableJobSchema)` to create a new message.
 */
export const UnavailableJobSchema: GenMessage<UnavailableJob> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 14);

/**
 * EngineStatus is one routing/solver/transit engine's health. Here every
 * engine is reported as "unchecked": this deployment cannot probe them.
 *
 * @generated from message travplaces.v1.EngineStatus
 */
export type EngineStatus = Message<"travplaces.v1.EngineStatus"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * "unchecked" here
   *
   * @generated from field: string state = 2;
   */
  state: string;

  /**
   * @generated from field: string detail = 3;
   */
  detail: string;
};

/**
 * Describes the message travplaces.v1.EngineStatus.
 * Use `create(EngineStatusSchema)` to create a new message.
 */
export const EngineStatusSchema: GenMessage<EngineStatus> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_city, 15);

/**
 * AdminCityService covers admin-only city catalogue writes plus the status
 * reads the legacy admin console exposed under /api/admin/cities and
 * /api/admin/system.
 *
 * FetchBoundary and SystemStatus are simplified: this deployment has no
 * external geocoder and no process/docker control, so FetchBoundary echoes the
 * city's own bounding box as the outline (percent_of_bbox=100, exact=false)
 * and SystemStatus reports database liveness only, listing the routing/solver/
 * transit engines as unchecked.
 *
 * @generated from service travplaces.v1.AdminCityService
 */
export const AdminCityService: GenService<{
  /**
   * ListAllCities returns every city in every status (incl. not-yet-ready).
   *
   * @generated from rpc travplaces.v1.AdminCityService.ListAllCities
   */
  listAllCities: {
    methodKind: "unary";
    input: typeof ListAllCitiesRequestSchema;
    output: typeof ListAllCitiesResponseSchema;
  },
  /**
   * CreateCity adds a city from its bounding box; the centre is the box mid.
   *
   * The request/response keep an Admin* prefix (rather than the lint-standard
   * CreateCityRequest/Response) because those names are already taken by
   * CityService in this same package.
   * buf:lint:ignore RPC_REQUEST_STANDARD_NAME
   * buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
   *
   * @generated from rpc travplaces.v1.AdminCityService.CreateCity
   */
  createCity: {
    methodKind: "unary";
    input: typeof AdminCreateCityRequestSchema;
    output: typeof AdminCreateCityResponseSchema;
  },
  /**
   * UpdateCity patches a city's mutable fields; unset fields are left as-is.
   *
   * @generated from rpc travplaces.v1.AdminCityService.UpdateCity
   */
  updateCity: {
    methodKind: "unary";
    input: typeof UpdateCityRequestSchema;
    output: typeof UpdateCityResponseSchema;
  },
  /**
   * DeleteCity removes a city and its POIs (cascade).
   *
   * Admin* prefix for the same reason as CreateCity: DeleteCityRequest/Response
   * already exist on CityService in this package.
   * buf:lint:ignore RPC_REQUEST_STANDARD_NAME
   * buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
   * UnpublishCity takes a city out of the planner and out of the shared map
   * and routing data, without deleting it.
   *
   * @generated from rpc travplaces.v1.AdminCityService.UnpublishCity
   */
  unpublishCity: {
    methodKind: "unary";
    input: typeof UnpublishCityRequestSchema;
    output: typeof UnpublishCityResponseSchema;
  },
  /**
   * @generated from rpc travplaces.v1.AdminCityService.DeleteCity
   */
  deleteCity: {
    methodKind: "unary";
    input: typeof AdminDeleteCityRequestSchema;
    output: typeof AdminDeleteCityResponseSchema;
  },
  /**
   * FetchBoundary reports the city's boundary coverage (simplified: bbox only).
   *
   * @generated from rpc travplaces.v1.AdminCityService.FetchBoundary
   */
  fetchBoundary: {
    methodKind: "unary";
    input: typeof FetchBoundaryRequestSchema;
    output: typeof FetchBoundaryResponseSchema;
  },
  /**
   * SystemStatus reports basic engine/health status (simplified: db liveness).
   *
   * @generated from rpc travplaces.v1.AdminCityService.SystemStatus
   */
  systemStatus: {
    methodKind: "unary";
    input: typeof SystemStatusRequestSchema;
    output: typeof SystemStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_admin_city, 0);

